class ProductCrossSell extends HTMLElement {
  constructor() {
    super();

    //Get Product Id
    this.productId = parseInt(this.getAttribute('product-id') ?? -1);
    this.variantId = parseInt(this.getAttribute('variant-id') ?? -1);
    this.quantity = parseInt(this.getAttribute('quantity') ?? 1);

    //Add to Cart Form
    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButton.addEventListener('click', this.onSubmit.bind(this));
  }
  async onSubmit(event) {
    event.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    //Add Disabled
    this.submitButton.setAttribute('aria-disabled', true);

    const formData = {
      items: [{
        id: this.variantId ? this.variantId : this.productId,
        quantity: this.quantity
      }]
    };

    //Config
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    };

    //Fire up the Fetch
    let result = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, config)
    if(!result.ok) {
      throw new Error(result);
      return
    }

    //Update Cart
    window.refreshCart();

    //Remove Disabled
    this.submitButton.removeAttribute('aria-disabled');
  }
}
customElements.define('product-cross-sell', ProductCrossSell);
